/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".padding-20[_ngcontent-%COMP%]{padding:1.25rem}.addCollegeContact[_ngcontent-%COMP%]{margin:1rem 0}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/admin-settings/components/college-contact/college-contact.component.scss.shim.ngstyle.js.pre-build-optimizer.js